export const DAILY_FREE_CHALLENGES = "daily_free_challenges"
export const DIAGNOSIS_CHALLENGE_MULTI_PLAYER_FREE_QUESTIONS = "diagnosis_challenge_multi_player_free_questions"
export const DIAGNOSIS_CHALLENGE_SINGLE_PLAYER_FREE_QUESTIONS = "diagnosis_challenge_single_player_free_questions"